import type { ReactNode } from 'react';
import { PlatformGuestOnly } from '@jarvis/platform-ui';
import { useAuthStore } from './useAuthStore';

/** Login route — signed-in users go home; insufficient roles use access-denied. */
export function GuestOnly({ children }: { children: ReactNode }) {
  return <PlatformGuestOnly useAuthStore={useAuthStore}>{children}</PlatformGuestOnly>;
}
